import React, {useEffect, useRef, useState} from 'react';
import {Platform, TouchableOpacity, View} from 'react-native';
import {noop} from 'lodash';
import {v4 as uuidv4} from 'uuid';

import Icon from '/component/base/Icon';
import ProfileAttribute from '/component/base/ProfileAttribute';
import Text from '/component/base/Text';
import TextInput from '/component/base/TextInput';

const KeyboardExtendedInput =
  Platform.OS === 'web'
    ? TextInput
    : require('react-native-external-keyboard').KeyboardExtendedInput;
import {IconNameByType} from '/component/partial/UrlDetailsPopover/UrlDetailsPopover.util';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import KeyboardFocusable from '../../../base/ExtKeyboard/KeyboardFocusable';

import {styles} from './CreateSocialLinks.style';
import {generateOpenSocialPopover} from './CreateSocialLinks.util';
interface LinkItem {
  id: string;
  label: string;
  iconName: string;
}
interface UrlDetailsItem {
  id: string;
  type: string;
  url?: string;
}
interface CreateSocialLinksProps {
  setSocialLinkText: (value: Map<string, {type: string; url: string}>) => void;
  socialLinkText: Map<string, {type: string; url: string}>;
  socialLinksError: boolean;
  setSocialLinksError: (value: boolean) => void;
  urlDetailsData: UrlDetailsItem[];
  popoverShow: () => void;
  seturlDetailsData: (value: UrlDetailsItem[]) => void;
  socialLinks: LinkItem[];
  setSocialLinks: (value: LinkItem[]) => void;
}

const CreateSocialLinks: React.FC<CreateSocialLinksProps> = ({
  setSocialLinkText,
  socialLinkText,
  socialLinksError = false,
  setSocialLinksError,
  urlDetailsData = [],
  popoverShow = noop,
  seturlDetailsData = noop,
  socialLinks = [],
  setSocialLinks = noop,
}) => {
  const {tt} = useTranslation('popover.socialLinks');
  const [isAddAnotherFocused, setIsAddAnotherFocused] = useState(false);
  const addLinkButtonRef = useRef(null);
  const addanotherLinkButtonRef = useRef(null);

  useEffect(() => {
    if (urlDetailsData && Array.isArray(urlDetailsData)) {
      const dataWithId = urlDetailsData.map(item => ({
        ...item,
        id: `${item.type}-${uuidv4()}`,
      }));
      seturlDetailsData(dataWithId);
    }
  }, []);

  const handlePressSocialLinks = (link: any) => {
    setSocialLinks(socialLinks.filter((filter: any) => filter.id !== link.id));
    socialLinkText.delete(link.id);
    setSocialLinkText(socialLinkText);
  };
  const handleChangeSocialLinksText = (text: any, link: any) => {
    if (text) {
      setSocialLinksError(false);
    } else {
      setSocialLinksError(true);
    }
    setSocialLinkText(
      socialLinkText.set(link.id, {
        type: link.label,
        url: text?.toString().toLowerCase(),
      }),
    );
  };
  const deleteByValue = (link: any) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    seturlDetailsData((urlDetailsData: any) => {
      return urlDetailsData.filter((val: any) => val.id !== link.id);
    });
    setSocialLinks(socialLinks.filter((filter: any) => filter.id !== link.id));
    socialLinkText.delete(link.id);
    setSocialLinkText(socialLinkText);
  };

  const linkTextHandleChange = (text: any, link: any) => {
    if (text) {
      setSocialLinksError(false);
    } else {
      setSocialLinksError(true);
    }
    seturlDetailsData((urlDetails: any) => {
      return urlDetails.map((val: any) => {
        if (val.id === link.id) {
          return {
            ...val,
            url: text?.toString().toLowerCase(),
          };
        }
        return val;
      });
    });
    setSocialLinkText(
      socialLinkText.set(link.id, {
        type: link.label,
        url: text?.toString().toLowerCase(),
      }),
    );
  };

  const renderSocialLinkFormEdit = () => {
    return urlDetailsData.map((link: any, index: any) => (
      <View
        key={index}
        style={styles.socialContainer}
        {...testProperties(DownlineProfile.candidateAddlinksBox + link.type)}>
        <ProfileAttribute
          // @ts-expect-error TS(2322): Type 'any[]' is not assignable to type 'string'.
          iconName={[IconNameByType[link.type]]}
          label={link.type}
          style={{base: styles.socialLink}}
          key={`pr${index}`}
          testID={DownlineProfile.candidateLinksBoxAddLinkTo + link.type}
        />
        <TouchableOpacity
          style={styles.closeButton}
          key={index}
          onPress={() => deleteByValue(link)}
          accessibilityRole="button"
          accessibilityLabel={`Remove ${link.type} link`}
          accessibilityHint="Double tap to remove this link"
          {...testProperties(null, true)}>
          <Icon name="close" />
        </TouchableOpacity>
        <Text
          style={styles.textLabel}
          {...testProperties(
            DownlineProfile.candidateLinksBoxAddlinksSubHeader,
          )}
          accessible={true}
          accessibilityLabel={'URL: (link to a website)'}>
          {tt('url', 'URL: (link to a website)')}
        </Text>
        <View style={styles.inputBox}>
          <TextInput
            value={link.url}
            {...(Platform.OS !== 'web' && {name: link.id})}
            style={styles.inputText}
            {...testProperties(DownlineProfile.candidateAddlinksBoxLinkInput)}
            onChangeText={(text: any) => linkTextHandleChange(text, link)}
          />
        </View>
      </View>
    ));
  };
  const renderSocialLinkForm = () => {
    return socialLinks.map((link: any) => (
      <View
        key={link.id}
        style={styles.socialContainer}
        {...testProperties(DownlineProfile.candidateAddlinksBox + link.label)}>
        <ProfileAttribute
          // @ts-expect-error TS(2322): Type 'any[]' is not assignable to type 'string'.
          iconName={[IconNameByType[link.iconName]]}
          label={link.label}
          style={{base: styles.socialLink}}
          key={`pr${link.id}`}
          testID={DownlineProfile.candidateAddlinksBox}
        />

        <TouchableOpacity
          style={styles.closeButton}
          key={link.id}
          accessibilityRole="button"
          accessibilityLabel="Close"
          onPress={() => handlePressSocialLinks(link)}
          {...testProperties(null, false)}>
          <Icon name="close" />
        </TouchableOpacity>
        <Text
          accessible={true}
          style={styles.textLabel}
          {...testProperties(
            DownlineProfile.candidateLinksBoxAddlinksSubHeader,
          )}
          accessibilityLabel={'URL: (link to a website)'}>
          {tt('url', 'URL: (link to a website)')}
        </Text>
        <View style={styles.inputBox}>
          <KeyboardExtendedInput
            onChangeText={(text: any) =>
              handleChangeSocialLinksText(text, link)
            }
            value={link.url}
            {...(Platform.OS !== 'web' && {name: link.id})}
            style={styles.inputText}
            autoCapitalize={'none'}
            {...testProperties(DownlineProfile.candidateAddlinksBoxLinkInput)}
          />
        </View>
      </View>
    ));
  };

  return (
    <View>
      <View>
        {urlDetailsData ? renderSocialLinkFormEdit() : null}
        {socialLinks.length > 0 || urlDetailsData?.length > 0 ? (
          <>
            {socialLinksError && (
              <Text
                style={styles.errorLabel}
                {...testProperties(DownlineProfile.candidateAddlinksError)}
                accessible={true}
                accessibilityLabel={
                  "Error: Ensure a valid url format example. 'https://www.domain.com'"
                }>{`Ensure a valid url format ex. 'https://www.domain.com'`}</Text>
            )}
            {renderSocialLinkForm()}
            <TouchableOpacity
              onPress={generateOpenSocialPopover(
                popoverShow,
                setSocialLinkText,
                setSocialLinks,
                socialLinkText,
                socialLinks,
                addanotherLinkButtonRef,
              )}
              ref={addanotherLinkButtonRef}
              accessibilityRole="button"
              accessibilityHint="Double tap to add a new social link"
              accessibilityLabel={'Add another link'}
              onFocus={() => setIsAddAnotherFocused(true)}
              onBlur={() => setIsAddAnotherFocused(false)}
              {...testProperties(null, true)}>
              <View
                style={[
                  styles.secondaryButton,
                  isAddAnotherFocused && styles.focusRing,
                ]}>
                <Text
                  accessible={true}
                  accessibilityRole="button"
                  style={[
                    styles.buttonText,
                    isAddAnotherFocused && styles.focusUnderline,
                  ]}
                  {...testProperties(
                    DownlineProfile.candidateAddAnotherLinkButton,
                  )}>
                  {tt('addanotherlink', 'Add another link')}
                </Text>
              </View>
            </TouchableOpacity>
          </>
        ) : (
          <KeyboardFocusable
            onPress={generateOpenSocialPopover(
              popoverShow,
              setSocialLinkText,
              setSocialLinks,
              socialLinkText,
              socialLinks,
              addLinkButtonRef,
            )}
            ref={addLinkButtonRef}
            accessibilityRole="button"
            accessibilityHint="Double tap to add a new social link"
            accessibilityLabel={'Add a link'}
            style={styles.buttonContainer}
            {...testProperties(null, true)}>
            <View>
              <Text
                accessible={true}
                accessibilityRole="button"
                variant="button"
                style={styles.button}
                testID={DownlineProfile.candidateAddLinkButton}>
                {tt('addlink', ' Add a link')}
              </Text>
            </View>
          </KeyboardFocusable>
        )}
      </View>
    </View>
  );
};

export default CreateSocialLinks;
